import { createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/package.svg'


const _withScopeId = n => (_pushScopeId("data-v-72282e1a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "package-body",
  draggable: "false"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  class: "package-icon"
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "icon-button package-button",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.submitInput()))
    }, _hoisted_3),
    _withDirectives(_createElementVNode("input", {
      class: "edit-name-input",
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.editedName) = $event)),
      onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.submitInput()), ["enter"]))
    }, null, 544), [
      [_vModelText, _ctx.editedName]
    ]),
    _createVNode(_Transition, { name: "bounce" }, {
      default: _withCtx(() => [
        (_ctx.editing && !_ctx.robotPackage)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "circle-button delete-btn",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onDelete()))
            }, " × "))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}